<template>
	<v-card
		class="nyYellow lighten-1 text-left chatWidget elevation-0"
		v-if="
			message.Attributes &&
				message.Attributes.MessageType === 'BookingModified'
		"
		:class="{ 'widget-right': view !== 'received' }"
	>
		<div class="pa-4">
			<div class="d-flex">
				<div class="flex-grow-0 pr-1">
					<BookingDateTimeDisplay
						:date="message.Attributes.BookingTime"
					/>
				</div>
				<div
					class="flex-grow-1 pl-1 d-flex flex-column justify-space-between"
				>
					<div>
						<div class="mb-2 poppins-semibold CardTitleSize">
							<span
								v-if="
									message.Attributes.BookingTypeId ===
										BookingTypesEnum.FREE
								"
								>{{ $t("freeVisit") }}</span
							>
							<span
								v-if="
									message.Attributes.BookingTypeId ===
										BookingTypesEnum.NORMAL
								"
								>{{ $t("normalVisit") }}</span
							>
							<span
								v-if="
									message.Attributes.BookingTypeId ===
										BookingTypesEnum.MEALPLAN
								"
								>{{ $t("mealPlan") }}</span
							>
						</div>
						<div class="text-right mt-auto">
							<v-btn
								text
								:to="
									'/Patients/Agenda/' +
										message.Attributes.BookingId
								"
								v-if="view === 'received'"
								>{{ $t("common.details") }}</v-btn
							>
							<v-btn
								text
								:to="
									'/AreaNutritionists/Bookings/' +
										message.Attributes.BookingId
								"
								v-else
								>{{ $t("common.details") }}</v-btn
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { BookingTypesEnum } from "@/components/NutriYou/nutriYouBookingTypesEnum";
import BookingDateTimeDisplay from "@/views/Patients/components/BookingDateTimeDisplay.vue";

export default {
	components: { BookingDateTimeDisplay },
	created() {
		this.BookingTypesEnum = BookingTypesEnum;
	},
	props: {
		message: {
			type: Object,
			required: true
		},

		view: {
			type: String,
			required: true,

			validator: value => {
				return ["sent", "received"].indexOf(value) !== -1;
			}
		}
	}
};
</script>

<i18n>
{
	"it": {
		"normalVisit": "Visita Nutrizionale Modificata!",
		"freeVisit": "Incontro Conoscitivo Modificato!",
		"mealPlan": "Consegna e spiegazione del piano Modificata!"
	}
}
</i18n>
